var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-5"},[_c('PageTitle',{attrs:{"title":"Login"}}),_c('div',{staticClass:"login"},[_vm._v("Please sign up or login in below.")]),_c('section',{attrs:{"id":"firebaseui-auth-container"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }